module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate12.a179532.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate12.png
// module id = 747
// module chunks = 0